var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStandardDefinition = function SvgStandardDefinition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "standardDefinition_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M554.667 298.667h128a128 128 0 0 1 128 128v170.666a127.957 127.957 0 0 1-128 128h-128zm128 341.333a42.667 42.667 0 0 0 42.666-42.667V426.667A42.667 42.667 0 0 0 682.667 384H640v256zm-384-341.333h170.666V384H298.667v85.333H384a85.333 85.333 0 0 1 85.333 85.334V640A85.333 85.333 0 0 1 384 725.333H213.333V640H384v-85.333h-85.333a85.333 85.333 0 0 1-85.334-85.334V384a85.333 85.333 0 0 1 85.334-85.333"
  })));
};
export default SvgStandardDefinition;